import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

import {
  ProjectType,
  CreateProjectType,
} from 'store/modules/projects/projects.types';

const URLS = {
  PROJECTS: '/org/%s/projects/',
  PROJECT: '/org/%s/projects/%s/',
  PROJECT_STATUS: '/org/%s/projects/%s/%s/',
  COLLECT_DATA: '/org/%s/projects/%s/collect/',
  GENERATE_BRAND_VALUATOR_REPORT:
    '/org/%s/projects/bav-charts-data/generate-charts/',
  GET_BRAND_VALUATOR_REPORT: '/org/%s/projects/bav-charts-data/%s/',
  APPLY_VOUCHER: '/org/%s/projects/%s/create_voucher/',
  REMOVE_VOUCHER: '/org/%s/projects/%s/delete_voucher/',
};

export default {
  getProjects: ({
    organizationCodename,
    params,
  }: {
    organizationCodename: string;
    params?: SearchParamsType;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.PROJECTS, organizationCodename),
      params: {
        ...params,
      },
    }),
  createProject: ({
    organizationCodename,
    project,
  }: {
    organizationCodename: string;
    project: CreateProjectType;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.PROJECTS, organizationCodename),
      data: project,
    }),
  getProject: ({
    organizationCodename,
    id,
  }: {
    id: ProjectType['id'] | string;
    organizationCodename: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.PROJECT, organizationCodename, id),
    }),
  updateProjectStatus: ({
    organizationCodename,
    project,
    status,
  }: {
    organizationCodename: string;
    project: ProjectType;
    status: 'edit' | 'accept';
  }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: sprintf(
        URLS.PROJECT_STATUS,
        organizationCodename,
        project.id,
        status
      ),
      data: {
        ...project,
      },
    });
  },
  updateProject: ({
    organizationCodename,
    project,
    surveyData,
  }: {
    organizationCodename: string;
    project: ProjectType;
    surveyData: { [key: string]: any };
  }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.PROJECT, organizationCodename, project.id),
      data: {
        ...project,
        json: {
          ...surveyData,
        },
      },
    });
  },
  updateProjectReminder: ({
    organizationCodename,
    project,
  }: {
    organizationCodename: string;
    project: ProjectType;
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.PROJECT, organizationCodename, project.id),
      data: {
        ...project,
      },
    }),
  removeProject: ({
    organizationCodename,
    id,
  }: {
    id: ProjectType['id'];
    organizationCodename: string;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.PROJECT, organizationCodename, id),
    }),
  collectProjectData: ({
    organizationCodename,
    id,
    val,
  }: {
    id: number | string;
    organizationCodename: string;
    val?: {
      terms: boolean;
      terms_agreement: boolean;
      privacy_policy_accepted: boolean;
    };
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.COLLECT_DATA, organizationCodename, id),
      data: val || {},
    }),
  generateBrandValuatorReport: ({
    organizationCodename,
    projectId,
  }: {
    projectId: number | string;
    organizationCodename: string;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.GENERATE_BRAND_VALUATOR_REPORT, organizationCodename),
      data: {
        project: projectId,
      },
    }),

  getBrandValuatorReport: ({
    organizationCodename,
    projectId,
  }: {
    projectId: number | string;
    organizationCodename: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(
        URLS.GET_BRAND_VALUATOR_REPORT,
        organizationCodename,
        projectId
      ),
    }),
  applyVoucher: ({
    organizationCodename,
    projectId,
    voucherCode,
  }: {
    projectId: number | string;
    organizationCodename: string;
    voucherCode: string;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.APPLY_VOUCHER, organizationCodename, projectId),
      data: {
        code: voucherCode,
      },
    }),
  removeVoucher: ({
    organizationCodename,
    projectId,
  }: {
    projectId: number | string;
    organizationCodename: string;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.REMOVE_VOUCHER, organizationCodename, projectId),
    }),
};
